import Vue from "vue";

const capitalizeLetter = {
  install(Vue) {
    Vue.prototype.$appCapitalizeLetter = {
      first: function (str) {
        if (str) {
          return str.charAt(0).toUpperCase() + str.slice(1);
        }
        return "";
      },
    };
  },
};
Vue.use(capitalizeLetter);
